// extracted by mini-css-extract-plugin
export var csatScore = "_k6-5";
export var header = "_k6-1";
export var panelWrapper = "_k6-2";
export var postPreview = "_k6-3";
export var rightContent = "_k6-0";
export var wrappingText = "_k6-4";